import { accordion } from "./modules/accordion";
import { itemAmountToggle } from "./modules/item-amount-toggler";
import { lazyBg } from "./modules/lazy-bg";
import { lazyLoad } from "./modules/lazy-load";
import { modal } from "./modules/modal";
import { navigation } from "./modules/navigation";
import { customSwiper } from "./modules/swiper";
import { smoothScroll } from "./modules/smooth-scroll";
import { validation } from "./modules/validation";
import { recaptchaDelay } from "./modules/recaptcha-delay";

function init() {
  accordion.init();
  itemAmountToggle.init();
  lazyBg.init();
  lazyLoad.init();
  modal.init();
  navigation.init();
  customSwiper.init();
  smoothScroll.init();
  validation.init();
  recaptchaDelay.init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}